export default __webpack_public_path__ + "static/media/close.1919ac72.svg";